function clear(number) {
  window.addEventListener('DOMContentLoaded', function () {
    document.querySelector(`#file_clear${number}`).addEventListener('click', function (e) {
      const upload = document.getElementById(`file_upload${number}`);
      const result = document.getElementById(`file${number}`);
      const cancel = document.getElementById(`file_clear${number}`);
      upload.value = '';
      result.parentNode.removeChild(result);
      cancel.style.display = 'none';
      upload.disabled = false;
      const label = upload.parentNode;
      label.classList.remove('p-index_disabled');
    });
  });
}

export function fileClear1() {
  clear(1);
}

export function fileClear2() {
  clear(2);
}

export function fileClear3() {
  clear(3);
}

export function fileClear4() {
  clear(4);
}

export function fileClear5() {
  clear(5);
}

export function fileClear6() {
  clear(6);
}

export function fileClear7() {
  clear(7);
}

export function fileClear8() {
  clear(8);
}

export function fileClear9() {
  clear(9);
}

export function fileClear10() {
  clear(10);
}
